export const MOCK_GATEWAYS = [
  { id: "gw-01", name: "cBerry-VanLife-Pro",   rssi: -42, hw: "v2.1", fw: "v1.8.2", btAddress: "CB:E1:00:A1:B2:C3" },
  { id: "gw-02", name: "cBerry-OffGrid-Cabin", rssi: -65, hw: "v1.5", fw: "v1.6.2", btAddress: "CB:E1:00:D4:E5:F6" },
  { id: "gw-03", name: "cBerry-YachtMaster",   rssi: -79, hw: "v2.0", fw: "v1.7.1", btAddress: "CB:E1:00:07:08:09" },
];
